<template>
  <div class="black-current-consume">

    <section class="dining-summary">
      <div>
        <span>桌号</span>
        <strong>{{ deskCode.code || "未绑定" }}</strong>
      </div>
      <button type="button" @click="openPeoplePopup">
        <span>人数</span>
        <strong>{{ currentPeople }}人⌄</strong>
      </button>
    </section>

    <section class="order-section">
      <header class="section-title">
        <h2>点餐信息</h2>
        <button type="button" class="active">按类型</button>
      </header>

      <div v-if="!categoryGroups.length" class="empty-state">还没有选择菜品</div>
      <article v-for="group in categoryGroups" v-else :key="group.id" class="goods-group">
        <h3>— {{ group.name }} —</h3>
        <div v-for="item in group.items" :key="getCartItemKey(item)" class="goods-row">
          <img :src="item.image || placeholderImage" :alt="item.name" />
          <div class="goods-main">
            <strong>{{ item.name }}</strong>
            <span>{{ getGoodsDescription(item) }}</span>
          </div>
          <div class="goods-side">
            <strong>¥{{ formatMoney(item.price) }}</strong>
            <div class="quantity-control">
              <button type="button" @click="changeGoodsQuantity(item, -1)">−</button>
              <span>{{ item.quantity }}</span>
              <button type="button" @click="changeGoodsQuantity(item, 1)">＋</button>
            </div>
          </div>
        </div>
        <footer>
          <span>{{ group.count }}份餐品 小计：</span>
          <strong>¥{{ formatMoney(group.total) }}</strong>
        </footer>
      </article>

      <div v-if="categoryGroups.length" class="order-total">
        <span>共{{ totalCount }}份餐品 合计：</span>
        <strong>¥{{ formatMoney(totalMoney) }}</strong>
      </div>
    </section>

    <section class="order-section" v-if="payType == 2">
      <header class="section-title">
        <h2>支付方式</h2>
      </header>
      <button type="button" class="pay-method" @click="openPayPopup">
        <div v-if="vpnInfo.KeyBindComponent === 0" class="pay-method-child">
          <span>挂手牌</span>
          <small
            v-if="vpnInfo.KeyBindComponent === 0 && (!deskCode.cardCode || deskCode.cardCode.length == 0)">微信扫一扫</small>
          <small v-else>{{ deskCode.cardCode }}</small>
        </div>


        <div v-if="vpnInfo.KeyBindComponent === 1" class="pay-method-child">
          <span>挂手牌</span>
          <small
            v-if="vpnInfo.KeyBindComponent === 1 && (!deskCode.cardCode || deskCode.cardCode.length == 0)">呼叫服务员</small>
          <small v-else>{{ deskCode.cardCode }}</small>
        </div>

        <div v-if="vpnInfo.KeyBindComponent === 2" class="pay-method-child">
          <span>挂手牌</span>
          <small
            v-if="vpnInfo.KeyBindComponent === 2 && (!deskCode.cardCode || deskCode.cardCode.length == 0)">手动输入</small>
          <small v-else>{{ deskCode.cardCode }}</small>
        </div>


        <i></i>
      </button>
    </section>

    <section class="order-section remark-section">
      <header class="section-title">
        <h2>订单备注</h2>
      </header>
      <div class="remark-box">
        <textarea v-model="orderRemark" maxlength="100" placeholder="其他需求，可以在此处给商家留言哦"></textarea>
        <span>{{ orderRemark.length }}/100</span>
      </div>
      <div class="quick-remarks">
        <button v-for="remark in quickRemarkList" :key="remark" type="button"
          :class="{ active: selectedRemarks.includes(remark) }" @click="toggleQuickRemark(remark)">
          {{ remark }}
        </button>
      </div>
    </section>

    <footer class="submit-bar">
      <strong>¥{{ formatMoney(totalMoney) }}</strong>
      <button type="button" class="continue-button" @click="handleContinueOrder">
        继续加菜
      </button>

      <button
        v-if="(!deskCode.cardCode || deskCode.cardCode.length <= 0) && vpnInfo.KeyBindComponent === 1 && vpnInfo.WaiterCallPurpose === 1 && payType === 2"
        type="button" class="submit-button" :disabled="!totalCount || isSubmitting" @click="callwaiterSubmit">
        呼叫服务员
      </button>
      <button
        v-else-if="payType === 2 || ((deskCode.cardCode && deskCode.cardCode.length > 0) && vpnInfo.KeyBindComponent === 1 && vpnInfo.WaiterCallPurpose === 1)"
        type="button" class="submit-button" :disabled="!totalCount || isSubmitting" @click="requestSubmit">
        手牌挂账
      </button>

      <button v-else-if="payType === 3" type="button" class="submit-button" :disabled="!totalCount || isSubmitting"
        @click="requestSubmit">
        餐台挂账
      </button>

      <button v-else-if="payType === 1" type="button" class="submit-button" :disabled="!totalCount || isSubmitting"
        @click="requestSubmit">
        立即支付
      </button>

    </footer>

    <van-popup v-model="showPeoplePopup" class="black-order-popup" position="bottom" round @closed="resetPeoplePopup">
      <section class="popup-panel">
        <header>
          <strong>选择用餐人数</strong>
          <button type="button" @click="closePeoplePopup">×</button>
        </header>
        <div class="people-grid">
          <button v-for="number in 12" :key="number" type="button" :class="{ active: pendingPeople === number }"
            @click="pendingPeople = number">
            {{ number }}人
          </button>
        </div>
        <footer>
          <button type="button" class="gold-button" @click="confirmPeople">确定</button>
        </footer>
      </section>
    </van-popup>

    <van-popup v-model="showKeyCodePopup" class="black-order-popup" position="bottom" round @closed="resetKeyCodePopup">
      <section class="popup-panel key-code-panel">
        <header>
          <strong>输入手牌号</strong>
          <button type="button" @click="closeKeyCodePopup">×</button>
        </header>
        <div class="key-code-content">
          <label for="black-key-code">手牌号</label>
          <input id="black-key-code" v-model.trim="pendingCardCode" type="text" maxlength="30" placeholder="请输入手牌号" />
        </div>
        <footer class="two-buttons">
          <button type="button" class="outline-button" @click="closeKeyCodePopup">
            取消
          </button>
          <button type="button" class="gold-button" @click="confirmKeyCode">
            确定
          </button>
        </footer>
      </section>
    </van-popup>

    <van-popup v-model="showSubmitConfirm" class="black-order-popup" position="bottom" round>
      <section class="popup-panel confirm-panel">
        <header>
          <strong>确认提交订单</strong>
          <button type="button" @click="showSubmitConfirm = false">×</button>
        </header>
        <p>共 {{ totalCount }} 份餐品，订单金额 ¥{{ formatMoney(totalMoney) }}</p>
        <footer class="two-buttons">
          <button type="button" class="outline-button" @click="showSubmitConfirm = false">
            再看看
          </button>
          <button type="button" class="gold-button" @click="confirmSubmit">
            确认下单
          </button>
        </footer>
      </section>
    </van-popup>

    <van-popup v-model="showUnpaidPopup" class="black-order-popup" position="bottom" round>
      <section class="popup-panel confirm-panel">
        <header><strong>存在未支付订单</strong></header>
        <p>您可以取消未支付订单后提交当前订单，或继续处理上一个订单。</p>
        <footer class="two-buttons">
          <button type="button" class="outline-button" @click="cancelPreviousOrder">
            取消旧订单
          </button>
          <button type="button" class="gold-button" @click="handlePreviousOrder">
            继续支付
          </button>
        </footer>
      </section>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { submitFoodOrder, getDiningRoomList } from "@/api/foodOrder";
import { handleSessionStorage, handleScanCode } from "@/utils";
import { getScanTakeNumber, waitercall } from "@/api/scan";
import { initConnect, handleSendMessage } from "@/utils/websorket";
import { EventBus } from "@/utils/eventbus";
export default {
  name: "BlackCurrentConsume",
  data() {
    return {
      deskCode: { code: "", cardCode: "", checkinId: "" },
      diningRoomInfo: {},
      vpnInfo: {},
      teamId: null,
      isGroupConfig: false,
      isSureVpn: false,
      currentPeople: 1,
      pendingPeople: 1,
      payType: 1,
      orderRemark: "",
      quickRemarkList: [],
      selectedRemarks: [],
      showPeoplePopup: false,
      showKeyCodePopup: false,
      pendingCardCode: "",
      showSubmitConfirm: false,
      showUnpaidPopup: false,
      isSubmitting: false,
      iscallwaiter: false,
      previousUnpaidOrderId: undefined,
      blackCartItems: [],
      placeholderImage: require("@/assets/black-micropoint/dish-placeholder.svg"),
      previousPageChromeTheme: null,
      teamGoodsListHandler: null,
      teamGoodsChangeHandler: null,
    };
  },
  computed: {
    ...mapState({
      storeOrderPeople: (state) => state.order.orderPeople,
    }),
    /**
     * 将 BlackMicropoint 独立缓存转换成按菜品类型展示的数据。
     * 同一分类下会汇总数量与金额，计算时对缺失数量和非法价格做安全处理。
     *
     * @returns {Array<{id: string|number, name: string, items: Array, count: number, total: number}>}
     */
    categoryGroups() {
      const groupMap = new Map();
      this.blackCartItems.forEach((item) => {
        const catalogId = item.catalogId || "uncategorized";
        if (!groupMap.has(catalogId)) {
          groupMap.set(catalogId, {
            id: catalogId,
            name: item.catalogName || "精选菜品",
            items: [],
            count: 0,
            total: 0,
          });
        }
        const group = groupMap.get(catalogId);
        const quantity = Math.max(0, Number(item.quantity) || 0);
        group.items.push(item);
        group.count += quantity;
        group.total += quantity * this.normalizePrice(item.price);
      });
      return Array.from(groupMap.values());
    },
    /**
     * 计算购物车全部餐品份数。
     *
     * @returns {number} 所有分类数量的合计。
     */
    totalCount() {
      return this.categoryGroups.reduce((total, group) => total + group.count, 0);
    },
    /**
     * 计算订单总金额。
     *
     * @returns {number} 所有分类小计的合计金额。
     */
    totalMoney() {
      return this.categoryGroups.reduce((total, group) => total + group.total, 0);
    },
  },
  created() {
    this.applyPageChromeTheme();
    this.initializePage();
    this.initializeTeamOrdering();
  },
  beforeRouteLeave(to, from, next) {
    this.removeTeamOrderingListeners();
    next();
  },
  beforeDestroy() {
    this.removeTeamOrderingListeners();
    this.restorePageChromeTheme();
  },
  methods: {

    queyDiningRoomList() {
      getDiningRoomList({ vpnId: this.vpnInfo.id })
        .then((res) => {
          const item = res.find((mode) => mode.Id == this.diningRoomId);
          if (item == undefined) {
            this.diningRoomInfo = res[0]
            this.diningRoomId = res[0].Id;
            handleSessionStorage.set("diningRoomId", res[0].Id);
            handleSessionStorage.set("diningRoomInfo", res[0]);
          } else {
            this.diningRoomInfo = item
            handleSessionStorage.set("diningRoomId", item.Id);
            handleSessionStorage.set("diningRoomInfo", item);
          }
          this.payType = Number(this.diningRoomInfo.PayMode) || 3;
          this.diningRoomInfo = handleSessionStorage.get("diningRoomInfo") || {};
          this.quickRemarkList = String(this.diningRoomInfo.Remark || "")
            .split(/[,，]/)
            .map((item) => item.trim())
            .filter(Boolean);
        })
        .catch((error) => { });
    },
    /**
     * 从会话缓存读取桌号、餐厅、门店、人数、快捷备注和多人点餐配置。
     * 缓存字段缺失时使用安全默认值，保证直接访问页面不会发生空对象异常。
     *
     * @returns {void}
     */
    initializePage() {
      this.deskCode = handleSessionStorage.get("deskCode") || { code: "", cardCode: "", checkinId: "" };
      this.vpnInfo = handleSessionStorage.get("vpnInfo") || {};
      this.teamId = handleSessionStorage.get("teamId") || null;
      this.isGroupConfig = this.normalizeSessionBoolean(handleSessionStorage.get("EnableTeamOrder"));
      this.isSureVpn = this.normalizeSessionBoolean(handleSessionStorage.get("isSureVpn"));
      this.currentPeople = Math.max(1, Number(this.storeOrderPeople) || 1);
      this.pendingPeople = this.currentPeople;
      const cachedCart = handleSessionStorage.get("blackMicropointCart");
      this.blackCartItems = Array.isArray(cachedCart)
        ? cachedCart.filter((item) => item && item.key)
        : [];
      this.queyDiningRoomList()
    },
    /**
     * 兼容会话缓存中的布尔值、数字开关和历史字符串值。
     * 明确排除 false、0 和 "false"，避免无权限场景被错误识别为团队点单。
     *
     * @param {*} value sessionStorage 读取出的开关值。
     * @returns {boolean} 规范化后的权限开关。
     */
    normalizeSessionBoolean(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    /**
     * 在订单确认页接入现有团队购物车通信。
     * 本方法仅操作 blackMicropointCart，不提交到原项目 shopCart Vuex 模块，
     * 因而不会改变 Micropoint 和 NewPlaceOrder 的团队点单实现。
     *
     * @returns {void}
     */
    initializeTeamOrdering() {
      if (!this.isTeamOrderActive()) return;
      this.teamGoodsChangeHandler = (data) => {
        this.applyTeamGoodsChange(data);
      };
      this.teamGoodsListHandler = (data, isClear) => {
        if (isClear) {
          this.blackCartItems = [];
          this.persistBlackCart();
          return;
        }
        this.replaceCartWithTeamGoods(data);
      };
      EventBus.$on("getMessage", this.teamGoodsChangeHandler);
      EventBus.$on("getGroupGoodsList", this.teamGoodsListHandler);
      initConnect();
      if (this.$store.state.pointConnet) {
        this.requestTeamGoodsList();
      }
    },
    /**
     * 检查团队点单开关、唯一门店状态和团队编号是否同时有效。
     *
     * @returns {boolean} true 表示当前订单允许使用团队购物车。
     */
    isTeamOrderActive() {
      return Boolean(
        this.isGroupConfig && this.isSureVpn && this.teamId
      );
    },
    /**
     * 请求当前团队的完整购物车。
     *
     * @returns {void}
     */
    requestTeamGoodsList() {
      if (!this.isTeamOrderActive()) return;
      handleSendMessage("SendGoodsList", {
        TeamId: this.teamId,
        duration: this.vpnInfo.OrderTeamDuration,
      });
    },
    /**
     * 精确移除订单确认页注册的团队事件，不影响其他页面的监听器。
     *
     * @returns {void}
     */
    removeTeamOrderingListeners() {
      if (this.teamGoodsChangeHandler) {
        EventBus.$off("getMessage", this.teamGoodsChangeHandler);
        this.teamGoodsChangeHandler = null;
      }
      if (this.teamGoodsListHandler) {
        EventBus.$off("getGroupGoodsList", this.teamGoodsListHandler);
        this.teamGoodsListHandler = null;
      }
    },
    /**
     * 将团队接口菜品转换为 BlackCurrentConsume 使用的购物车条目。
     *
     * @param {Object} goods 团队接口菜品。
     * @param {number} quantity 菜品数量。
     * @returns {Object|null} 可展示和提交的黑色购物车条目。
     */
    normalizeTeamCartItem(goods, quantity) {
      if (!goods || typeof goods !== "object") return null;
      const goodsId = goods.Id != null ? goods.Id : goods.ProductId;
      if (goodsId == null) return null;
      const isSetMeal = Number(goods.IsServiceId || goods.GoodsServiceId) === 6;
      const specId = isSetMeal
        ? "setmeal"
        : goods.SpecificId != null
          ? String(goods.SpecificId)
          : "default";
      const remarkText = String(
        goods.remark || goods.Remark || ""
      ).trim();
      const packageSelections = goods.PackageSelections || [];
      const menuGoods =
        goods.MenuGoods ||
        packageSelections.map((mealItem) => ({
          GoodsId: mealItem.goodsId,
          GoodsName: mealItem.goodsName,
          GoodsCode: mealItem.goodsCode,
          Price: mealItem.price,
          NumberCount: mealItem.numberCount || 1,
        }));
      return {
        key:
          goods.BlackCartKey ||
          `${goodsId}_${specId}_${remarkText}`,
        goodsId,
        catalogId: goods.GoodsCatalogId,
        catalogName: goods.GoodsCatalog || goods.ProductType || "精选菜品",
        name: goods.GoodsName || goods.ProductName || "",
        image: goods.PicUrl || "",
        specId,
        specName: goods.Specification || (isSetMeal ? "套餐" : "标准份"),
        price: this.normalizePrice(goods.Price),
        remarkText,
        quantity: Math.max(0, Number(quantity) || 0),
        isSetMeal,
        packageSelections,
        sourceGoods: { ...goods, MenuGoods: menuGoods },
      };
    },
    /**
     * 用服务端返回的团队购物车覆盖订单确认页，并合并相同条目。
     *
     * @param {Array<Object>} goodsList 团队购物车完整列表。
     * @returns {void}
     */
    replaceCartWithTeamGoods(goodsList) {
      if (!Array.isArray(goodsList)) return;
      const itemMap = new Map();
      goodsList.forEach((goods) => {
        const item = this.normalizeTeamCartItem(goods, goods.Quantity);
        if (!item || item.quantity <= 0) return;
        const existing = itemMap.get(item.key);
        if (existing) {
          existing.quantity += item.quantity;
        } else {
          itemMap.set(item.key, item);
        }
      });
      this.blackCartItems = Array.from(itemMap.values());
      this.persistBlackCart();
    },
    /**
     * 把其他成员发来的数量增减应用到当前确认页。
     *
     * @param {Object} goods 团队实时变更消息。
     * @returns {void}
     */
    applyTeamGoodsChange(goods) {
      if (!goods || !Number(goods.Quantity)) return;
      const incoming = this.normalizeTeamCartItem(
        goods,
        Math.abs(Number(goods.Quantity))
      );
      if (!incoming) return;
      const index = this.blackCartItems.findIndex(
        (item) => item.key === incoming.key
      );
      const nextQuantity =
        (index >= 0 ? Number(this.blackCartItems[index].quantity) : 0) +
        Number(goods.Quantity);
      if (nextQuantity <= 0) {
        if (index >= 0) this.blackCartItems.splice(index, 1);
      } else if (index >= 0) {
        this.blackCartItems[index].quantity = Math.min(99, nextQuantity);
      } else {
        incoming.quantity = Math.min(99, nextQuantity);
        this.blackCartItems.push(incoming);
      }
      this.persistBlackCart();
    },
    /**
     * 将确认页的本地数量变化按原团队协议广播。
     *
     * @param {Object} item 黑色购物车条目。
     * @param {number} quantityChange 正数增加，负数减少。
     * @returns {void}
     */
    sendTeamGoodsChange(item, quantityChange) {
      if (!this.isTeamOrderActive() || !item || !quantityChange) return;
      const sourceGoods = item.sourceGoods || {};
      const isMultiSpecific =
        item.specId !== "default" && item.specId !== "setmeal";
      const params = {
        TeamId: this.teamId,
        Quantity: Number(quantityChange),
        TableCode: this.deskCode.code,
        VpnId: this.vpnInfo.id,
        duration: this.vpnInfo.OrderTeamDuration,
        GoodsCatalog: item.catalogName,
        GoodsCatalogId: item.catalogId,
        GoodsName: item.name,
        Id: item.goodsId,
        IsMultiSpecific: isMultiSpecific,
        IsServiceId: item.isSetMeal ? 6 : sourceGoods.IsServiceId,
        PicUrl: item.image,
        Price: item.price,
        MinBuyCount: sourceGoods.MinBuyCount,
        remark: item.remarkText,
        BlackCartKey: item.key,
        PackageSelections: item.packageSelections || [],
        MenuGoods:
          sourceGoods.MenuGoods ||
          (item.packageSelections || []).map((mealItem) => ({
            GoodsId: mealItem.goodsId,
            GoodsName: mealItem.goodsName,
            GoodsCode: mealItem.goodsCode,
            Price: mealItem.price,
            NumberCount: mealItem.numberCount || 1,
          })),
      };
      if (isMultiSpecific) {
        params.SpecificId = item.specId;
        params.Specification = item.specName;
      }
      if (sourceGoods.MethodName || sourceGoods.DoWay) {
        params.DoWay = sourceGoods.MethodName || sourceGoods.DoWay;
      }
      if (sourceGoods.Taste) params.Taste = sourceGoods.Taste;
      handleSendMessage("SendChangeGoods", params);
    },
    /**
     * 通知团队服务端清空购物车。
     *
     * @returns {void}
     */
    sendTeamGoodsClear() {
      if (!this.isTeamOrderActive()) return;
      handleSendMessage("SendGoodsClear", {
        TeamId: this.teamId,
        duration: this.vpnInfo.OrderTeamDuration,
      });
    },
    /**
     * 将金额转换成有限数字，支持包含人民币符号和千位逗号的字符串。
     *
     * @param {number|string|null|undefined} value 原始金额。
     * @returns {number} 可安全参与计算的数字，非法值返回 0。
     */
    normalizePrice(value) {
      const number = Number(String(value == null ? "" : value).replace(/[¥,\s]/g, ""));
      return Number.isFinite(number) ? number : 0;
    },
    /**
     * 格式化金额，整数不显示小数，非整数最多保留两位。
     *
     * @param {number|string} value 金额。
     * @returns {string} 页面展示金额。
     */
    formatMoney(value) {
      return this.normalizePrice(value)
        .toFixed(2)
        .replace(/\.00$/, "")
        .replace(/(\.\d)0$/, "$1");
    },
    /**
     * 生成购物车行的稳定 key，区分套餐组合、规格和口味做法。
     *
     * @param {Object} item 购物车菜品。
     * @returns {string} Vue 列表渲染 key。
     */
    getCartItemKey(item) {
      return item.key;
    },
    /**
     * 组合菜品的规格、做法、口味和套餐摘要。
     *
     * @param {Object} item 购物车菜品。
     * @returns {string} 菜品名称下方的补充说明。
     */
    getGoodsDescription(item) {
      return [item.specName, item.remarkText]
        .filter(Boolean)
        .join(" · ");
    },
    /**
     * 增加或减少购物车菜品数量。
     * 增加时校验源菜品的限点和沽清数量；减少时遵循 MinBuyCount 规则。
     * 修改后立即保存独立缓存，只同步 BlackMicropoint，不触碰原项目 Vuex 购物车。
     *
     * @param {Object} item 需要修改的购物车菜品。
     * @param {number} direction 1 增加，-1 减少。
     * @returns {void}
     */
    changeGoodsQuantity(item, direction) {
      if (!item || !direction) return;
      const sourceGoods = item.sourceGoods || {};
      const minimumQuantity = Math.max(
        1,
        Number(
          sourceGoods.MinBuyCount != null
            ? sourceGoods.MinBuyCount
            : item.MinBuyCount
        ) || 1
      );
      if (direction > 0) {
        const step = minimumQuantity;
        if (
          sourceGoods.RestrictionCount &&
          Number(item.quantity) + step > Number(sourceGoods.RestrictionCount)
        ) {
          this.$toast("添加数量超过餐品限点数量");
          return;
        }
        if (
          sourceGoods.IsSellOut &&
          Number(sourceGoods.SellOutNumber) !== 0 &&
          Number(item.quantity) + step > Number(sourceGoods.SellOutNumber)
        ) {
          this.$toast("添加数量超过餐品沽清数量，无法添加哦");
          return;
        }
        if (Number(item.quantity) + step > 99) {
          this.$toast("单个菜品最多选择 99 份");
          return;
        }
        item.quantity += step;
        this.persistBlackCart();
        this.sendTeamGoodsChange(item, step);
        return;
      }
      const step =
        Number(item.quantity) - minimumQuantity > 0 ? 1 : minimumQuantity;
      const nextQuantity = Number(item.quantity) - step;
      if (nextQuantity <= 0) {
        const index = this.blackCartItems.findIndex(
          (cartItem) => cartItem.key === item.key
        );
        if (index >= 0) this.blackCartItems.splice(index, 1);
        this.sendTeamGoodsChange(item, -Number(item.quantity));
      } else {
        item.quantity = nextQuantity;
        this.sendTeamGoodsChange(item, -step);
      }
      this.persistBlackCart();
    },
    /**
     * 保存提交页中修改后的黑色购物车。
     * 与 BlackMicropoint 使用同一个独立缓存 key，返回点餐页后数量保持一致。
     *
     * @returns {void}
     */
    persistBlackCart() {
      handleSessionStorage.set(
        "blackMicropointCart",
        this.blackCartItems.map((item) => ({ ...item }))
      );
    },
    /**
     * 打开人数选择弹窗，并复制当前人数作为临时值。
     *
     * @returns {void}
     */
    openPeoplePopup() {
      this.pendingPeople = this.currentPeople;
      this.showPeoplePopup = true;
    },
    /**
     * 关闭人数弹窗，临时选择不会写入订单。
     *
     * @returns {void}
     */
    closePeoplePopup() {
      this.showPeoplePopup = false;
    },
    /**
     * 人数弹窗关闭后的状态回收。
     *
     * @returns {void}
     */
    resetPeoplePopup() {
      this.pendingPeople = this.currentPeople;
    },
    /**
     * 确认人数并同步到 Vuex order 模块。
     *
     * @returns {void}
     */
    confirmPeople() {
      this.currentPeople = this.pendingPeople;
      this.$store.commit("order/setOrderPeople", this.currentPeople);
      this.showPeoplePopup = false;
    },
    /**
     * 打开独立支付方式底部弹窗。
     *
     * @returns {void}
     */
    openPayPopup() {
      console.log("this.deskCode.cardCode===== " + this.deskCode.cardCode)
      if ((this.deskCode.cardCode && this.deskCode.cardCode.length >= 1)) {
        return
      }
      if (this.vpnInfo.KeyBindComponent === 0) {
        this.handleBindCard()
      } else if (this.vpnInfo.KeyBindComponent === 1) {
        this.callwaiterSubmit()
      } else if (this.vpnInfo.KeyBindComponent === 2) {
        this.pendingCardCode = this.deskCode.cardCode || "";
        this.showKeyCodePopup = true;
      }
    },
    /**
     * 关闭手牌号输入弹窗。
     * 未确认的输入不会写入桌台缓存，也不会影响当前订单的 KeyCode。
     *
     * @returns {void}
     */
    closeKeyCodePopup() {
      this.showKeyCodePopup = false;
    },
    /**
     * 手牌号弹窗关闭后的临时状态清理。
     * 下次打开时会重新从 deskCode.cardCode 回显当前已保存的手牌号。
     *
     * @returns {void}
     */
    resetKeyCodePopup() {
      this.pendingCardCode = "";
    },
    /**
     * 校验并保存手动输入的手牌号。
     * 保存方式与项目 PayComps 一致：更新当前页面 deskCode，并同步写入
     * sessionStorage，后续订单提交时直接使用 deskCode.cardCode 作为 KeyCode。
     *
     * @returns {void}
     */
    confirmKeyCode() {
      const cardCode = String(this.pendingCardCode || "").trim();
      if (!cardCode) {
        this.$toast("请输入手牌号");
        return;
      }
      this.deskCode = {
        ...this.deskCode,
        checkinId: "",
        cardCode,
      };
      handleSessionStorage.set("deskCode", { ...this.deskCode });
      this.showKeyCodePopup = false;
    },

    /***呼叫服务员并且提交消费明细**/
    callwaiterAndSubmitConsume() {
      if (this.iscallwaiter === true) {
        this.$toast("正在提交中，请不要重复提交")
        return
      }
      if ((!this.deskCode.code || this.deskCode.code.length == 0)) {
        this.$toast("当前没有桌台,联系店家处理");
        return
      }
     
      this.iscallwaiter = true
      let foodsList = [];

      this.$toast("提交中，请稍后……")

      waitercall({
        DinnerRoomId: this.diningRoomInfo.Id,
        VpnId: this.vpnInfo.id,
        TableCode: this.deskCode.code,
        TotalAmount: this.totalMoney,
        PersonNum: this.currentPeople,
        Remark: (this.orderRemark ? this.orderRemark + "；" : "") + this.selectedRemarks.join(),
        Items: this.buildSubmitItems(),
        PayType: 2, //手牌挂账
      }).then((res) => {
        this.$toast("呼叫服务员成功")
        this.sendTeamGoodsClear();
        handleSessionStorage.remove("blackMicropointCart");
        this.$router.go(-1);
      }).catch((err) => {
        this.iscallwaiter = false
        this.$toast("呼叫服务员失败：" + err)
      });
    },

    //呼叫服务员
    callwaiterSubmit() {
      if (this.vpnInfo.WaiterCallPurpose == 1) {
        this.callwaiterAndSubmitConsume()
      } else {
        waitercall({
          VpnId: this.vpnInfo.id,
          TableCode: this.deskCode.code
        }).then((res) => {
          this.showCallWaiterDialog = true
        }).catch((err) => {
          this.$toast("呼叫服务员失败：" + err)
        });
      }
    },

    handleBindCard() {
      // this.$emit("sweepCode", type);
      // 调起微信扫码，
      handleScanCode({ needResult: 1 }, (res) => {
        const cardCodeData = res.resultStr;
        if (!cardCodeData) {
          this.$toast("二维码为空，请确认后重新扫码");
          return;
        }
        var vpncodeQuery = ""
        var uuidQuery = ""
        const pageQueryArr = cardCodeData.split("?M=");
        if (pageQueryArr instanceof Array && pageQueryArr.length == 2) {
          const orgString = pageQueryArr[1];
          const arr = orgString.split('@');
          if (arr instanceof Array && arr.length == 2) {
            uuidQuery = arr[0],
              vpncodeQuery = arr[1]
          }
        }
        console.log("pageQuery 数据加载中 ==== " + uuidQuery)
        console.log("pageQuery  门店参数code  ==== " + vpncodeQuery)
        //  this.$toast("扫码拿到的数据："+uuidQuery+"vpncodeQuery"+vpncodeQuery);
        if ((!uuidQuery || !vpncodeQuery)) {
          this.$toast("二维码缺少必要参数，请确认后重新扫码");
          return;
        }
        let queryData = {
          IsBind: true,
          BindingUuid: uuidQuery,
          VpnCode: vpncodeQuery
        };
        getScanTakeNumber(queryData)
          .then((res) => {
            this.deskCode.cardCode = res.TableCode
            // this.$toast("扫码绑定结果："+JSON.stringify(res));
            const deskObj = handleSessionStorage.get("deskCode");
            handleSessionStorage.set("deskCode", {
              ...deskObj,
              checkinId: res.CheckinId,
              cardCode: res.TableCode,
            });
            this.$emit("handleResetCardInfo");
          })
          .catch((err) => {
            this.$toast("绑定手牌失败：" + err)
          });
      });
    },

    /**
     * 切换快捷备注，可同时选择多个。
     *
     * @param {string} remark 快捷备注。
     * @returns {void}
     */
    toggleQuickRemark(remark) {
      const index = this.selectedRemarks.indexOf(remark);
      if (index >= 0) this.selectedRemarks.splice(index, 1);
      else this.selectedRemarks.push(remark);
    },
    /**
     * 打开独立的提交确认底部弹窗。
     *
     * @returns {void}
     */
    requestSubmit() {
      if (!this.totalCount || this.isSubmitting) return;
      if (this.payType === 2 && !this.deskCode.cardCode) {
        this.$toast("暂未绑定手牌，请先绑定手牌");
        return;
      }
      this.showSubmitConfirm = true;
    },
    /**
     * 确认提交，关闭确认弹窗后调用订单接口。
     *
     * @returns {void}
     */
    confirmSubmit() {
      this.showSubmitConfirm = false;
      this.submitOrder();
    },
    /**
     * 将购物车菜品转换成 submitFoodOrder 接口 Items。
     * 套餐沿用 NewPlaceOrder 的 SubMealDTOs 结构，并兼容 BlackMicropoint
     * 保存的 packageSelections 数据。
     *
     * @returns {Array<Object>} 后端订单菜品数组。
     */
    buildSubmitItems() {
      const items = [];
      this.categoryGroups.forEach((group) => {
        group.items.forEach((item) => {
          const sourceGoods = item.sourceGoods || {};
          const quantity = Number(item.quantity) || 0;
          const submitItem = {
            ProductId: item.goodsId,
            ProductName: item.name,
            ProductType: item.catalogName || group.name,
            Quantity: quantity,
            Remark: item.remarkText || "",
            GoodsServiceId: item.isSetMeal ? 6 : sourceGoods.IsServiceId,
          };
          if (
            item.specId &&
            item.specId !== "default" &&
            item.specId !== "setmeal"
          ) {
            submitItem.SpecificId = item.specId;
            submitItem.Specification = item.specName;
          }
          if (item.isSetMeal) {
            const mealGoods = item.sourceGoods.MenuGoods || [];
            submitItem.SubMealDTOs = mealGoods.map((mealItem) => ({
              GoodsId: mealItem.GoodsId,
              GoodsName: mealItem.GoodsName,
              GoodsCode: mealItem.GoodsCode,
              Price: this.normalizePrice(mealItem.Price),
              GoodsServiceId: 6,
              NumberCount: quantity * (mealItem.NumberCount || 1),
              Quantity: quantity * (mealItem.NumberCount || 1),
            }));
          }
          items.push(submitItem);
        });
      });
      return items;
    },
    /**
     * 组织与 NewPlaceOrder 一致的订单参数并调用提交接口。
     * 防重复标记会覆盖完整异步周期；若存在未支付订单，则打开本页面独立弹窗。
     *
     * @returns {Promise<void>} 提交请求结束后完成。
     */
    async submitOrder() {
      if (this.isSubmitting || !this.totalCount) return;

      if ((!this.deskCode.code || this.deskCode.code.length == 0)) {
        this.$toast("当前没有桌台,联系店家处理");
        return
      }

      if (this.payType === 2 && (!this.deskCode.cardCode || this.deskCode.cardCode.length == 0)) {
        this.$toast("请选绑定手牌，再提交");
        return
      }

      this.isSubmitting = true;
      const requestData = {
        DinnerRoomId: this.diningRoomInfo.Id,
        TeamId: this.isGroupConfig && this.isSureVpn ? this.teamId : null,
        VpnId: this.vpnInfo.id,
        PayType: this.payType,
        KeyCode: this.deskCode.cardCode,
        CheckinId: this.deskCode.checkinId,
        TableCode: this.deskCode.code,
        PersonNum: this.currentPeople,
        TotalAmount: this.totalMoney,
        Remark: (this.orderRemark ? `${this.orderRemark}；` : "") + this.selectedRemarks.join(),
        Items: this.buildSubmitItems(),
        CancelOrderId: this.previousUnpaidOrderId,
      };
      try {
        const response = await submitFoodOrder(requestData);
        if (response && response.UnPaidOrderId && response.UnPaidOrderId !== null) {
          this.previousUnpaidOrderId = response.UnPaidOrderId;
          this.showUnpaidPopup = true;
          return;
        }
        this.previousUnpaidOrderId = null;
        this.sendTeamGoodsClear();
        this.blackCartItems = [];
        handleSessionStorage.remove("blackMicropointCart");
        this.handleSubmitSuccess(response);
      } catch (error) {
        this.$toast("订单提交失败:" + error);
      } finally {
        this.isSubmitting = false;
      }
    },
    /** 
     * 取消旧的未支付订单后重新提交当前订单。
     * 后端通过 CancelOrderId 完成旧订单取消，本方法不执行页面跳转。
     *
     * @returns {void}
     */
    cancelPreviousOrder() {
      this.showUnpaidPopup = false;
      this.submitOrder();
    },
    /**
     * “继续支付上一订单”的页面跳转预留方法。
     * 按需求保持空实现，待目标页面确认后再接入路由。
     *
     * @returns {void}
     */
    handlePreviousOrder() {
      // 页面跳转预留。
      this.$router.push({ name: "BlackRecordConsume", });
    },
    /**
     * 订单提交成功后的页面跳转预留方法。
     *
     * @param {Object} response submitFoodOrder 成功响应。
     * @returns {void}
     */
    handleSubmitSuccess(response) {
      // 页面跳转预留：在线支付与挂账成功页暂不跳转。
      if (this.payType == 1) {
        //在线支付
        this.$router.replace({
          name: "PayList",
          query: { id: response.OrderId, fromPage: "food" },
        });
      } else {
        this.$router.replace("BlackPlaceOrderSuccess");
      }
    },
    /**
     * 继续加菜的跳转预留方法。
     *
     * @returns {void}
     */
    handleContinueOrder() {
      // 页面跳转预留。
      this.$router.go(-1);
    },
    /**
     * 顶部更多按钮预留方法。
     *
     * @returns {void}
     */
    handleMore() {
      // 功能预留。
    },
    /**
     * 应用与 BlackMicropoint 一致的深色浏览器背景，避免顶部安全区露白。
     *
     * @returns {void}
     */
    applyPageChromeTheme() {
      this.previousPageChromeTheme = {
        htmlBackground: document.documentElement.style.backgroundColor,
        bodyBackground: document.body.style.backgroundColor,
      };
      document.documentElement.style.backgroundColor = "#171717";
      document.body.style.backgroundColor = "#171717";
    },
    /**
     * 离开页面时恢复进入前的浏览器背景。
     *
     * @returns {void}
     */
    restorePageChromeTheme() {
      if (!this.previousPageChromeTheme) return;
      document.documentElement.style.backgroundColor =
        this.previousPageChromeTheme.htmlBackground;
      document.body.style.backgroundColor =
        this.previousPageChromeTheme.bodyBackground;
    },
  },
};
</script>

<style scoped lang="scss">
.black-current-consume {
  min-height: 100vh;
  padding: 0 24px calc(160px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #f7f4ee;
  background-color: #1F232B;
  background-image: none;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.page-header {
  display: flex;
  height: 112px;
  padding-top: env(safe-area-inset-top);
  align-items: flex-end;
  justify-content: space-between;
  box-sizing: border-box;

  h1 {
    margin: 0 0 23px;
    font-size: 30px;
    line-height: 42px;
  }

  button {
    width: 70px;
    height: 70px;
    padding: 0;
    margin-bottom: 10px;
    border: 0;
    color: #fff;
    background: transparent;
    font-size: 34px;
  }
}

.dining-summary {
  display: flex;
  gap: 24px;
  margin: 22px 0;
  padding-top: 22px;


  >div,
  >button {
    display: flex;
    height: 70px;
    padding: 0 22px;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(226, 187, 91, 0.25);
    border-radius: 5px;
    color: #f4f1e9;
    background: rgba(35, 35, 35, 0.78);
    font-size: 22px;
  }

  strong {
    color: #d8d5cd;
    font-size: 21px;
    font-weight: 400;
  }
}

.order-section {
  margin-bottom: 24px;
}

.section-title {
  display: flex;
  height: 62px;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin: 0;
    font-size: 28px;
  }

  button {
    position: relative;
    padding: 8px 0;
    border: 0;
    color: #f1c85f;
    background: transparent;
    font-size: 20px;

    &.active::after {
      position: absolute;
      right: 4px;
      bottom: 0;
      left: 4px;
      height: 3px;
      border-radius: 2px;
      background: #edc45c;
      content: "";
    }
  }
}

.goods-group {
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #383E50;
  border-radius: 10px;
  background: #383E50;

  h3 {
    margin: 0 0 15px;
    color: #f0c75d;
    font-size: 22px;
    text-align: center;
  }

  footer {
    display: flex;
    padding-top: 14px;
    justify-content: flex-end;
    color: #aaa69f;
    font-size: 18px;

    strong {
      margin-left: 6px;
      color: #f1ca63;
    }
  }
}

.goods-row {
  display: flex;
  min-height: 102px;
  padding: 12px 0;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  >img {
    width: 82px;
    height: 82px;
    border-radius: 6px;
    object-fit: cover;
  }
}

.goods-main {
  display: flex;
  min-width: 0;
  margin-left: 14px;
  flex: 1;
  flex-direction: column;

  strong {
    overflow: hidden;
    font-size: 21px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    margin-top: 7px;
    overflow: hidden;
    color: #aaa69f;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.goods-side {
  display: flex;
  margin-left: 12px;
  align-items: flex-end;
  flex-direction: column;

  >strong {
    margin-bottom: 10px;
    color: #f1ca63;
    font-size: 20px;
  }
}

.quantity-control {
  display: flex;
  align-items: center;

  button {
    width: 36px;
    min-width: 36px;
    height: 36px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    color: #2e240d;
    background: #f2cc68;
    font-size: 22px;
    line-height: 36px;
  }

  span {
    min-width: 34px;
    color: #fff;
    font-size: 18px;
    text-align: center;
  }
}

.order-total {
  display: flex;
  padding: 18px 8px 4px;
  justify-content: flex-end;
  color: #aaa69f;
  font-size: 20px;

  strong {
    margin-left: 7px;
    color: #f1ca63;
  }
}

.pay-method {
  display: flex;
  width: 100%;
  height: 68px;
  padding: 0 22px;
  align-items: center;
  border: 1px solid rgba(226, 187, 91, 0.22);
  border-radius: 5px;
  color: #f6f2e9;
  background: rgba(35, 35, 35, 0.78);
  font-size: 21px;


  small {
    flex: 1;
    text-align: right;
    margin-left: auto;
    color: #aaa69f;
    font-size: 18px;
  }

  i {
    width: 20px;
    height: 20px;
    margin-left: 18px;
    border: 5px solid #f1c75e;
    border-radius: 50%;
    box-sizing: border-box;
  }
}

.pay-method-child {
  width: 100%;
  display: flex;
}

.remark-box {
  position: relative;

  textarea {
    width: 100%;
    height: 180px;
    padding: 18px 20px 40px;
    border: 1px solid rgba(226, 187, 91, 0.22);
    border-radius: 5px;
    box-sizing: border-box;
    color: #fff;
    background: rgba(35, 35, 35, 0.78);
    font-size: 20px;
    line-height: 30px;
    outline: 0;
    resize: none;

    &::placeholder {
      color: #777;
    }
  }

  >span {
    position: absolute;
    right: 16px;
    bottom: 12px;
    color: #999;
    font-size: 17px;
  }
}

.quick-remarks {
  display: flex;
  padding-top: 12px;
  flex-wrap: wrap;
  gap: 10px;

  button {
    min-width: 80px;
    height: 40px;
    padding: 0 18px;
    border: 1px solid #676767;
    border-radius: 20px;
    color: #ccc8c0;
    background: rgba(30, 30, 30, 0.65);
    font-size: 17px;

    &.active {
      border-color: #edc45c;
      color: #f0ca63;
      background: rgba(83, 68, 36, 0.82);
    }
  }
}

.submit-bar {
  position: fixed;
  z-index: 20;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: calc(96px + env(safe-area-inset-bottom));
  padding: 0 24px env(safe-area-inset-bottom);
  align-items: center;
  gap: 12px;
  /* border-top: 1px solid #d9aa49; */
  background: #171817;

  >strong {
    margin-right: auto;
    color: #f3ce69;
    font-size: 28px;
  }

  button {
    width: 208px;
    height: 68px;
    padding: 0 24px;
    border: 0;
    border-radius: 34px;
    color: #32394b;
    background: linear-gradient(135deg, #f8d57b, #efb94f);
    font-size: 27px;
    font-weight: 600;
  }

  .continue-button {
    border: 0;
    color: #32394b;
    background: linear-gradient(135deg, #f8d57b, #efb94f);
  }

  .submit-button {
    width: 208px;
    height: 68px;
    padding: 0 24px;
    border: 0;
    border-radius: 34px;
    color: #32394b;
    background: linear-gradient(135deg, #f8d57b, #efb94f);
    font-size: 27px;
    font-weight: 600;

    &:disabled {
      color: #777;
      background: #444;
    }
  }
}

.empty-state {
  padding: 80px 20px;
  color: #999;
  text-align: center;
}

.black-order-popup,
.popup-panel {
  color: #f6f2e9;
  background-color: #2E3240;
  background-image: none;
}

.black-order-popup {
  max-height: 82vh;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}

.popup-panel {
  min-height: 320px;

  >header {
    display: flex;
    min-height: 82px;
    padding: 0 26px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(226, 187, 91, 0.28);

    strong {
      font-size: 27px;
    }

    button {
      border: 0;
      color: #e1bd5d;
      background: transparent;
      font-size: 28px;
    }
  }

  >footer {
    padding: 14px 24px calc(14px + env(safe-area-inset-bottom));
    border-top: 1px solid rgba(226, 187, 91, 0.28);
  }
}

.people-grid {
  display: grid;
  padding: 24px;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;

  button {
    height: 54px;
    border: 1px solid #555;
    border-radius: 5px;
    color: #dededb;
    background: rgba(48, 48, 48, 0.78);
    font-size: 19px;

    &.active {
      border-color: #edc45c;
      color: #f4ca60;
      background: #4b4029;
    }
  }
}

.pay-options {
  padding: 22px 24px calc(22px + env(safe-area-inset-bottom));

  button {
    display: flex;
    width: 100%;
    height: 70px;
    padding: 0 20px;
    margin-bottom: 12px;
    align-items: center;
    border: 1px solid #555;
    border-radius: 6px;
    color: #f2eee6;
    background: rgba(48, 48, 48, 0.78);
    font-size: 21px;

    small {
      margin-left: auto;
      color: #999;
      font-size: 17px;
    }

    &.active {
      border-color: #edc45c;
      color: #f4ca60;
      background: #4b4029;
    }
  }
}

.key-code-panel {
  min-height: 330px;
}

.key-code-content {
  padding: 34px 24px;

  label {
    display: block;
    margin-bottom: 12px;
    color: #f0c75d;
    font-size: 21px;
  }

  input {
    width: 100%;
    height: 62px;
    padding: 0 18px;
    border: 1px solid #555;
    border-radius: 5px;
    box-sizing: border-box;
    color: #fff;
    background: rgba(48, 48, 48, 0.78);
    font-size: 21px;
    outline: 0;

    &::placeholder {
      color: #858585;
    }

    &:focus {
      border-color: #edc45c;
    }
  }
}

.confirm-panel {
  >p {
    padding: 46px 30px;
    margin: 0;
    color: #d7d3ca;
    font-size: 21px;
    line-height: 34px;
    text-align: center;
  }
}

.two-buttons {
  display: flex;
  gap: 16px;

  button {
    height: 68px;
    flex: 1;
    border-radius: 34px;
    font-size: 23px;
  }
}

.gold-button {
  width: 100%;
  height: 68px;
  padding: 0 24px;
  border: 0;
  border-radius: 34px;
  color: #32394b;
  background: linear-gradient(135deg, #f8d57b, #efb94f);
  font-size: 27px;
  font-weight: 600;
}

.outline-button {
  border: 1px solid #caa64e;
  color: #e2bd60;
  background: transparent;
}
</style>
